<po-page-default p-title="Dependency Track">
  
  <div class="po-row">
    <po-button
      class="po-sm-6 po-md-6 po-lg-3 po-xl-2"
      (p-click)="addProject()"
      p-icon="po-icon-plus"
      p-kind="primary"
      p-label="Adicionar projeto"
    />

    <po-button
      class="po-sm-6 po-md-6 po-lg-3 po-xl-2"
      (p-click)="refreshProjects()"
      p-icon="po-icon-refresh"
      p-kind="secondary"
      p-label="Atualizar"
      [p-loading]="loading"
      [p-disabled]="!projects.length"
    />

    <po-button
      class="po-sm-6 po-md-6 po-lg-3 po-xl-2"
      (p-click)="toggleFilters()"
      p-icon="po-icon-filter"
      p-label="Filtros"
    />

    <po-button
      class="po-sm-6 po-md-6 po-lg-3 po-xl-2"
      (p-click)="toggleComponents()"
      p-icon="po-icon-search"
      p-label="Componentes"
    />
  </div>
  
  <div *ngIf="showComponents" class="po-row po-mt-2">
    <div class="po-sm-12 po-p-0 po-m-0">

      <div class="po-font-large-bold po-mb-2 po-sm-12">
        <strong>Filtros de Componente</strong>
      </div>

      <div class="po-row">
        <po-input
          class="po-sm-12 po-md-6 po-lg-4"
          p-label="Nome"
          p-placeholder="Ex: ajv, po-ui..."
          [(ngModel)]="filterComponentName"
        />

        <po-input
          class="po-sm-12 po-md-6 po-lg-4"
          p-label="Versão"
          p-placeholder="Ex: 21.0.0"
          [(ngModel)]="filterComponentVersion"
        />
      </div>

    </div>
  </div>

  <div *ngIf="showFilters" class="po-row po-mt-2">
    <div class="po-sm-12 po-p-0 po-m-0">

      <div class="po-row">
        <po-input
          class="po-sm-12 po-md-6 po-lg-4"
          name="projectName"
          p-clean
          [(ngModel)]="projectName"
          p-label="Projeto"
          p-placeholder="Nome do projeto"
        />

        <po-input
          class="po-sm-12 po-md-6 po-lg-3"
          name="filterProductOwner"
          p-clean
          [(ngModel)]="filterProductOwner"
          p-label="Product Owner (PO)"
          p-placeholder="E-mail do PO"
        />
     
        <po-multiselect 
          class="po-sm-12 po-md-6 po-lg-3 custom-multiselect"
          name="filterTeam"
          [(ngModel)]="filterTeam"
          p-label="Time"
          p-placeholder="Selecione o(s) time(s)"
          [p-options]="teamFilterOptions"
          p-filter-mode="contains"
        />

        <po-select
          class="po-sm-12 po-md-6 po-lg-2"
          name="filterStatus"
          [(ngModel)]="filterStatus"
          p-label="Status"
          p-placeholder="Selecione o status"
          [p-options]="statusFilterOptions"
        />
      </div>

      <div class="po-row po-mt-2">
        <po-input
          class="po-sm-12 po-md-6 po-lg-4"
          name="filterVulnerability"
          p-clean
          [(ngModel)]="filterVulnerability"
          p-label="Vulnerabilidade"
          p-placeholder="Ex: GHSA-4r6h-8v6p-xvw6"
          p-help="Identificador CVE ou GHSA da vulnerabilidade"
        />

        <po-select
          class="po-sm-12 po-md-6 po-lg-3"
          name="filterSeverity"
          [(ngModel)]="filterSeverity"
          p-label="Nível de severidade"
          p-placeholder="Selecione o nível de severidade"
          [p-options]="severityFilterOptions"
        />
      </div>

    </div>
  </div>

  <div *ngIf="showFilters || showComponents" class="po-row po-mt-4 po-sm-12">
    <po-button
      class="po-sm-6 po-md-3 po-lg-2"
      (p-click)="search()"
      p-icon="po-icon-search"
      p-kind="primary"
      p-label="Pesquisar"
      [p-loading]="loading"
    />

    <po-button
      class="po-sm-6 po-md-3 po-lg-2"
      (p-click)="clearFilters()"
      p-icon="po-icon-close"
      p-kind="tertiary"
      p-label="Limpar filtros"
      [p-disabled]="!hasActiveFilters()"
    />
  </div>

  <po-divider></po-divider>

  <div class="po-p-0 po-m-0" style="position: relative">
    <po-list-view
      p-hide-select-all
      [p-actions]="listActions"
      [p-items]="projects"
      p-property-title="name"
      [p-show-more-disabled]="!hasNext || loading"
      (p-show-more)="showMore()"
    >
      <ng-template p-list-view-content-template let-project>

        <div *ngIf="!isComponentSearch || !project.components || project.components.length === 0" class="po-row">
          <po-info
            p-label="Repositório"
            class="po-md-5"
            [p-value]="project.repository"
          />

          <po-info
            p-label="Branch"
            class="po-md-1"
            [p-value]="project.branch"
          />

          <po-info
            p-label="Publicado"
            class="po-md-1"
            [p-value]="isPublished(project.rpo)"
          />

          <po-tag
            p-label="Status"
            class="po-md-1"
            [p-orientation]="vertical"
            [p-type]="getStatusType(project.status)"
            [p-value]="getStatusLabel(project.status)"
          />

          <po-info
            p-label="Product Owner (PO)"
            class="po-md-3"
            [p-value]="project.product_owner"
          />

          <po-info
            p-label="Time"
            class="po-md-2 po-mt-2"
            [p-value]="project.team"
          />

          <po-info
            p-label="Adicionado por"
            class="po-md-3 po-mt-2 "
            [p-value]="project.created_by"
          />

          <po-info
            p-label="Adicionado em"
            class="po-md-3 po-mt-2"
            [p-value]="project.created_at | date : 'shortDate'"
          />

          <po-info
            p-label="Última análise"
            class="po-md-2 po-mt-2" 
            [p-value]="(analyzing && projectAnalyzed === project.id ? 'Analisando...' : (project.last_scan | date : 'short')) || 'Indisponível'"
          />
        </div> 

        <div *ngIf="isComponentSearch && project.components && project.components.length > 0" class="po-row">
          <po-info p-label="Repositório" class="po-md-12" [p-value]="project.repository" />

          <div class="po-md-12 po-mt-2">
            <div class="po-font-text-bold po-mb-1">
              PURL(s) presente no projeto
            </div>

            <ul class="po-m-0 po-pl-3">
              <li *ngFor="let comp of project.components" class="po-font-text po-mb-1">
                {{ comp.purl }}
              </li>
            </ul>
            
          </div>
        </div>

      </ng-template>
    </po-list-view>

    <po-loading-overlay *ngIf="loading" />
  </div>

</po-page-default>

<app-dependency-track-vulnerabilities />
<app-dependency-track-project (onSave)="onSaveProject($event)" />

<po-modal
  #modalDeleteProject
  p-size="sm"
  [p-click-out]="false"
  [p-hide-close]="true"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction"
>
  <p>
    Tem certeza que deseja excluir este projeto? Esta ação não pode ser desfeita.
  </p>

  <br />

  <po-input
    name="input"
    p-label="Confirme o nome do projeto"
    p-help="Atenção! O projeto e o histórico de análises serão excluídos somente do banco de dados, não do Dependency Track."
    [p-placeholder]="placeHolderProjectName"
    [(ngModel)]="projectNameToDelete"
    [ngModelOptions]="{ standalone: true }"
    (p-change-model)="onProjectNameToDeleteChange()"
  />
</po-modal>
